import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class ContributorGroupService extends CrudService {
  constructor() {
    super('contributorGroups')
  }
}

export default ContributorGroupService
